import styled from 'styled-components';
import { shade } from 'polished';

interface OptionProps {
  selected: boolean;
}

interface ContinueButtonProps {
  enabled: boolean;
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: row;
  margin-left: 20px;
`;

export const OptionsContainer = styled.div`
  height: 15%;
  display: flex;
  width: 20%;
  flex-direction: column;
  justify-content: space-between;
`;

export const Option = styled.div<OptionProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    height: 30px;
    width: 30px;
    border: 1px solid #999;
    border-radius: 50px;
    background: ${(props) => (props.selected ? '#ccc' : 'transparent')};
  }
  p {
    margin-left: 10px;
  }
`;

export const Content = styled.div`
  width: 90%;
`;
